import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import Loading from '../common/Loading.js';
import settings from '../../constants/settings.js';
import ErrorMessage from '../common/ErrorMessage.js';

class FindMe extends React.Component {
    constructor(props, context) {
        super(props, context);
     }

    componentDidMount() {  
        if((!this.props.artist.Address && !this.props.artist.AddressStatus) || this.props.artist.AddressStatus === 'FAILED') {
            this.props.actions.getAddress(this.props.artist.Username);
        }
    }

    render() {
        const artist = this.props.artist;
        const actions = this.props.actions;
        const key = settings.GOOGLEPLACES_KEY;
        return (
            artist.AddressStatus === 'FAILED' ?
                <ErrorMessage error="Sorry, something went wrong! Unable to load address." />
                :
                artist.Address && artist.Address.Address ?
                    <div>
                        <span className="biotext"><b>Address:</b> {artist.Address.Address}</span>
                        <br />
                        <br />    
                        <div className="embed-container">
                            <iframe width="520" height="400" frameBorder="0" src={`https://www.google.com/maps/embed/v1/place?q=${encodeURIComponent(artist.Address.Address)}&zoom=16&key=${key}`} />
                        </div>
                    </div>
                    : (artist.AddressStatus === 'LOADING' ?
                    <Loading /> : <p className="biotext">Coming soon...</p>)
        );
    }
}

FindMe.propTypes = {
    artist: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired
};

export default FindMe;